<div class="absolute inset-0">
    <!-- Main -->
    <ng-container *transloco="let t">
        <div
            class="flex h-full flex-auto flex-col items-center justify-center p-6 sm:p-10"
        >
            <!-- prettier-ignore -->
            <div class="w-full max-w-3xl">
                <img src="/images/pages/auth/cat.svg" alt="Error 404" class="w-full h-full object-cover" />
            </div>
            <div
                class="mt-12 text-center text-4xl font-extrabold leading-tight tracking-tight sm:mt-24 md:text-7xl md:leading-none"
            >
                {{ t('error.unauthorized') }}
            </div>
            <div
                class="text-secondary mt-2 text-center text-lg font-medium tracking-tight md:text-xl"
            >
                {{ t('error.no-permission') }}
            </div>
            <div class="mt-12 flex flex-row items-center justify-center">
                <a
                    class="text-primary-500 underline"
                    [routerLink]="['/sign-in']"
                >
                    {{ t('auth.sign-in') }}
                </a>
                <span class="text-secondary mx-2">{{ t('common.or') }}</span>
                <a class="text-primary-500 underline" href="/">
                    {{ t('common.back-home') }}
                </a>
            </div>
        </div>
    </ng-container>
</div>
